import axios from "axios";
import { BASE_URL_MIDDLEWARE } from "../constants/config";
import type { Collection, FormContactPayload } from "../types/form.types";

type ResponseData = {
  data: Collection[];
};

const api = axios.create({
  baseURL: BASE_URL_MIDDLEWARE,
});

export const getProvinces = async () => {
  return (await api.get<ResponseData>("/api/departments")).data.data;
};

export const getCities = async (id: number) => {
  return (await api.get<ResponseData>(`/api/cities/department/${id}`)).data
    .data;
};

export const getReasons = async () => {
  const response = await api.get<ResponseData>("/api/reasons");
  return response.data.data;
};

export const sendContact = async (payload: FormContactPayload) => {
  return await api.post("/api/contact", payload);
};
